var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightLeftSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_997_27545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.18789 5.06251H19.0629V1.68751C19.0629 1.00723 19.4742 0.39024 20.107 0.126569C20.7398 -0.137103 21.4623 0.0105529 21.9475 0.490436L27.01 5.55294C27.3264 5.86934 27.5057 6.29649 27.5057 6.74473C27.5057 7.19297 27.3264 7.62012 27.01 7.93653L21.9475 12.999C21.4623 13.4842 20.7398 13.6266 20.107 13.3629C19.4742 13.0992 19.0629 12.4875 19.0629 11.802V8.4375H2.18789C1.25449 8.4375 0.500391 7.6834 0.500391 6.75001C0.500391 5.81661 1.25449 5.06251 2.18789 5.06251ZM25.8129 18.5625C26.7463 18.5625 27.5004 19.3166 27.5004 20.25C27.5004 21.1834 26.7463 21.9375 25.8129 21.9375H8.93789V25.3125C8.93789 25.9928 8.52656 26.6098 7.89375 26.8734C7.26094 27.1371 6.53848 26.9895 6.05332 26.5096L0.99082 21.4471C0.674414 21.1307 0.495117 20.7035 0.495117 20.2553C0.495117 19.807 0.674414 19.3799 0.99082 19.0635L6.05332 14.001C6.53848 13.5158 7.26094 13.3734 7.89375 13.6371C8.52656 13.9008 8.93789 14.5125 8.93789 15.1981V18.5731H25.8129V18.5625Z",
    fill: "#919191"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_997_27545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLeftSolid);
export default __webpack_public_path__ + "static/media/right-left-solid.e2ebd1f2db7efe3e9f372fd7e0027060.svg";
export { ForwardRef as ReactComponent };